import React, { useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Mail, CheckCircle, ArrowLeft } from 'lucide-react';

export default function CheckEmailPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || 'votre adresse email';

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <Mail className="w-12 h-12 text-blue-600" />
        </div>
        <h2 className="mt-6 text-center text-3xl font-bold text-gray-900">
          Vérifiez votre boîte mail
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Nous avons envoyé un code de vérification à
        </p>
        <p className="mt-1 text-center text-sm font-medium text-gray-900">
          {email}
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="text-center">
            <div className="flex justify-center mb-4">
              <div className="rounded-full bg-blue-100 p-3">
                <Mail className="w-8 h-8 text-blue-600" />
              </div>
            </div>
            
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              Consultez votre boîte de réception
            </h3>
            
            <p className="text-sm text-gray-600 mb-6">
              Un email contenant un code de vérification vous a été envoyé. 
              Veuillez vérifier votre boîte de réception (et vos spams si nécessaire) 
              et cliquez sur le lien de confirmation pour réinitialiser votre mot de passe.
            </p>

            <div className="bg-blue-50 border border-blue-200 rounded-md p-4 mb-6">
              <div className="flex items-start">
                <CheckCircle className="w-5 h-5 text-blue-600 mt-0.5 mr-2 flex-shrink-0" />
                <div className="text-sm text-blue-800">
                  <p className="font-medium mb-1">Vérifiez votre identité</p>
                  <p>Cliquez sur le lien dans l'email pour confirmer que c'est bien vous et accéder à la réinitialisation de votre mot de passe.</p>
                </div>
              </div>
            </div>

            <div className="space-y-3">
              <a
                href={`https://mail.google.com/mail/u/0/#search/in:inbox`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full flex justify-center items-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                <Mail className="w-4 h-4 mr-2" />
                Ouvrir Gmail
              </a>

              <button
                onClick={() => navigate('/reset-password', { state: { email } })}
                className="w-full flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                J'ai reçu le code, continuer
              </button>
            </div>

            <div className="mt-6 pt-6 border-t border-gray-200">
              <p className="text-xs text-gray-500 mb-3">
                Vous n'avez pas reçu l'email ?
              </p>
              <Link
                to="/forgot-password"
                className="text-sm text-blue-600 hover:text-blue-500"
              >
                Renvoyer l'email
              </Link>
            </div>

            <div className="mt-6">
              <Link
                to="/login"
                className="flex items-center justify-center text-sm text-gray-600 hover:text-gray-500"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Retour à la connexion
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
